export default "__VITE_ASSET__CIkGYdXM__"